import React from 'react';
import Schedule from './schedule'
import styles from './pearlDoser.module.css'
import LoadingSpinner from '../loadingSpinner'
import {wsTrans} from '../../utils/utils'
import { contSaveSchedule,readJPro,readXBoards} from "../C18AiUtils";
import {cl,globs,getRandomString} from '../../../components/utils/utils';

class DoserSchedule extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      loaded:false,
      recipes:[
      ],
      schedule:[
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
    ],
    }
    this.schedRef=React.createRef()
    this.subscribe_savePageEvent=globs.events
      .subscribe("savePageEvent",this.savePage)
  }

  componentDidMount=()=>{
    this.loadInfo()
  }

  componentWillUnmount=()=>{
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  adjustSchedule=(schedule,jPlus)=>{
//     cl(schedule)
//     schedule??=[]
//     if(!schedule){schedule=[]}
    let schedCnt=12/((jPlus||[].filter(jp=>!jp.notUsed)).length||1)
//     cl(schedCnt)
    if(schedule.length<schedCnt){
      for(let i=schedule.length;i<schedCnt;i++){
        schedule.push({
          recipeId:"none",
          dayMins:0,
          durMins:0
        })
      }
    }else{
      for(let i=schedule.length-1;i>schedCnt;i--){
        delete schedule[i]
      }
    }
    for(let [i,s] of schedule.entries()){
      if(!s){schedule[i]={
        recipeId:"none",
        dayMins:0,
        durMins:0
      }}
    }
//     cl(schedule)
  }

  loadInfo=async()=>{
    let pa=this.props.parms
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
    let body={
      zoneId:pa.zone,
    }
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: body})
    let stateVals={
      loaded:true,
//       jPro:readJPro(zone.siteZoneIndex,0),
      xBoards:readXBoards(zone.siteZoneIndex),
      zInd:zone.siteZoneIndex,
    }
    for(let val of res.data){// read jPlus, recipes, schedule
      stateVals[val.type]=val.value
    }
    if(!stateVals.schedule){stateVals.schedule=[]}
    this.adjustSchedule(stateVals.schedule,stateVals.jPlus);
    stateVals.jPro=readJPro(zone.siteZoneIndex,
      stateVals.xBoards,(stateVals.jPlus||[]).length);
    (stateVals.schedule||[]).forEach(s=>{
      if(!s.durMins){s.durMins=0}
    })
//     stateVals.schedule=schedule
    this.setState((stateVals))
  }

  doSave=async(field)=>{
    let pa=this.props.parms
    let st=this.state
    let body={
      zoneId:pa.zone,
      type:field,
      value:st[field]
    }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
  }

  savePage=async()=>{
    let st=this.state
//     cl(st)
//     cl("savePage")
    globs.events.publish("savePageEnable",false)
//     if(st.editRecipes){
//       this.saveEditRecipe()
//       await this.doSave("recipes")
//     }
    if(st.editSchedule){
      await this.doSave("schedule")
      await contSaveSchedule(st.schedule,st.recipes,st.jPro,st.zInd)
      this.setState({editSchedule:false})
      this.props.onChange({type:"change",value:null})
    }
//     if(st.editTimeEnables){await this.doSave("timeEnables")}
//     if(st.editJPlus){await this.doSave("jPlus")}
    globs.events.publish("saveOK",true)
  }

  validateSched=(sched)=>{
//     cl("validate")
//     cl(sched)
    let sched2=sched.slice(0)
    sched2.sort((a,b)=>{
      return a.dayMins-b.dayMins
    })
    sched2=sched2.filter(s=>s.durMins)
    let errs=[]
    for(let i=0;i<sched2.length-1;i++){
      let s=sched2[i]
      let s2=sched2[i+1]
      s.err=s.dayMins+s.durMins>s2.dayMins
      if(s.err){
        s.durMins=s2.dayMins-s.dayMins
        cl("err")
      }
    }
//     if(sched2.filter(s=>s.err).length){
//       setTimeout(e=>{
//         sched2.forEach(s=>s.err=false)
//         this.setState({upd:this.state.upd||0+1})
//       },2000)
//     }
//     cl(sched2)
//     cl(sched)
  }

  onScheduleChange=(values)=>{
//     cl(values)
    let st=this.state
    let schedule=st.schedule.slice(0)
    globs.events.publish("savePageEnable",true)
    this.props.onChange({type:"change",value:this.savePage})
    switch(values.type){
      case "time":
        schedule[values.index-1].dayMins=values.value
        break
      case "recipe":
        schedule[values.index-1].recipeId=values.value
        break
      case "duration":
        schedule[values.index-1].durMins=values.value
        break
      case "err":
        schedule[values.index-1].err=values.value
        break
    }
    this.validateSched(schedule)
    this.setState({schedule,editSchedule:true/*,jpEdit:"none"*/})
    if((values.type=="time")&&
      schedule.filter(s=>s.err).length){// err after time change
        setTimeout(e=>{
          schedule.forEach(s=>s.err=false)
          this.schedRef.current.updateDurStrs()
          this.setState({upd:this.state.upd||0+1})
        },2000)
      }
  }

  render(){
    let st=this.state
//     cl(st)
    if(st.loaded){
      return(
        <div className={styles.pearlDoser}
        style={{padding:20}}
          onMouseDown={this.pageMouseDown}
        >
          <h3>Schedule</h3>
          <Schedule ref={this.schedRef}
            recipeNames={st.recipes}
            schedule={st.schedule}
            onChange={this.onScheduleChange}
          /><br/>
        </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
  }
}

export default DoserSchedule;
